import { replaceTempUUid } from "api/exchanges/exchangeUtils";
import type { ExchangeClient, ExchangeOperation } from "api/exchanges/types";

type ExeDeleteNodeFromQueueParams = {
  operation: ExchangeOperation;
  client: ExchangeClient;
  queue: Set<ExchangeOperation>;
  replaceKeysMap: Map<string, string>;
};

export const exeDeleteNodeFromQueue = ({
  operation,
  client,
  queue,
  replaceKeysMap,
}: ExeDeleteNodeFromQueueParams): void => {
  const id = operation.variables?.id;

  if (id && id.startsWith("temp_")) {
    if (operation.variables) {
      operation.variables.id = replaceTempUUid({
        id,
        replaceKeysMap,
      });
    }
  }

  client.reexecuteOperation({
    ...operation,
    context: {
      ...operation.context,
      requestPolicy: "network-only",
      fromQueue: true,
    },
  });
  queue.delete(operation);
};
